import React from 'react';
import WomanImg from '../img/contact/woman.png';
import { motion } from 'framer-motion';
import { transition1 } from '../transitions';

const Contact = () => {
  const mailtoLink = 'mailto:shawarpan@gmail.com';

  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='section bg-[#7F00FF]'>
      <div className='container mx-auto h-full'>
        <div className='flex flex-col lg:flex-row h-full items-center justify-start pt-36 gap-x-8 text-center lg:text-left'>
          {/* bg */}
          <div className='hidden lg:flex bg-[#eef7f9] absolute bottom-0 left-0 right-0 top-72 -z-10'></div>
          {/* text and form */}
          <div className='lg:flex-1 lg:pt-32 px-4'>
            <h1 className='h1'>Contact me</h1>
            
            <motion.form
              initial={{ opacity: 0, y: '-80%' }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: '-80%' }}
              transition={transition1}
              className='flex flex-col gap-y-4'>
              <div className='flex gap-x-10'>
                <input
                  className='outline-none border-b border-b-primary h-[60px] bg-transparent font-secondary w-full pl-3 placeholder:text-[#757879]'
                  
                  placeholder='Phone Number'
                  value='PhoneN0: 8820106150'
                  readOnly
                />
              </div>

              <div>
                <input
                  className='outline-none border-b border-b-primary h-[60px] bg-transparent font-secondary w-full pl-3 placeholder:text-[#757879]'
                  type='text'
                  placeholder='Email'
                  value='Email: shawarpan@gmail.com'
                  readOnly
                />
              </div>
              <div>
                <input
                  className='outline-none border-b border-b-primary h-[60px] bg-transparent font-secondary w-full pl-3 placeholder:text-[#757879]'
                  type='text'
                  placeholder='Address'
                  value='Address: Urdibazar, Chandannagar, Hooghly-712136'
                  readOnly
                />
              </div>
              <a href={mailtoLink} className='btn mb-[30px] mx-auto lg:mx-0 self-start'>
                Mail me
              </a>
            </motion.form>
          </div>
          {/* images */}
          <div className='lg:flex-1'>
            <img src={WomanImg} alt='' />
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Contact;
